import { native } from './nativeCore.js'
const nativeApi = {
  /**
    * @function 文件预览接口
    * @description
    * @param url {string} 下载地址
    * @param type {string} 文件类型
    * @param fileName {string} 文件名称
    * @returns {Promise}
    * @author kongxiangcheng 2022.07.06
    */
  previewFile: function (url, type, fileName) {
    let param = JSON.stringify({
      url: url,
      type: type,
      fileName: fileName
    })
    return native.previewFile(param)
  },
  /**
    * @function 签名接口(不推荐使用！！！！！！！！！)
    * @description
    * @param inData {string} 签名原文
    * @returns {Promise}
    * @author kongxiangcheng 2022.07.06
    */
  signData: function (inData) {
    let param = JSON.stringify({
      inData: inData
    })
    return native.signData(param)
  },
  /**
    * @function 签名接口(推荐使用！！！！！！！！！！)
    * @description
    * @param inData {string} 签名原文
    * @returns {Promise}
    * @author kongxiangcheng 2023.08.22
    */
  signatureData: function (inData) {
    let param = JSON.stringify({
      inData: inData
    })
    return native.signatureData(param)
  },  
  /**
    * @function 扫描二维码接口
    * @description
    * @returns {Promise}
    * @author kongxiangcheng 2022.07.06
    */
  scanQR: function () {
    return native.scanQR()
  },
  /**
    * @function 定位接口
    * @description
    * @returns {Promise}
    * @author kongxiangcheng 2022.07.06
    */
  getLocation: function (mode, altitude) {
    let param = JSON.stringify({
      mode: mode,
      altitude: altitude
    })
    return native.getLocation(param)
  },
    /**
      * @function 参加视频会议接口
      * @description
      * @returns {Promise}
      * @author songyuhui 2024.12.12
      */
    joinMeeting: function (meetingNo, meetingPd, displayName = '用户', turnOnCamera = false, turnOnMic = false) {
      let param = JSON.stringify({
        meetingNo: meetingNo,
        meetingPd: meetingPd,
        turnOnCamera: turnOnCamera,
        turnOnMic: turnOnMic,
        displayName: displayName
      })
      return native.joinMeeting(param)
    },
   /**
    * @function 获取图片接口
    * @description
    * @returns {Promise}
    * @author kongxiangcheng 2022.08.10
    */
  getImage: function (count, sourceType,compressLevel,camera,type='') {
    let param = JSON.stringify({
      count: count,
      sourceType: sourceType,
      compressLevel: compressLevel,
      camera: camera,
      type:type
    })
	console.log('1.执行native.getImage')
    return native.getImage(param)
  },
  /**
    * @function 返回首页接口
    * @description
    * @param router {number} 返回上一层（单一使用）
    * @returns void
    * @author kongxiangcheng 2022.07.19
    */
  goPage: function (router) {
    let param = {
      router: router,
    }
    native.goPage(param)
  },
  /**
    * @function 返回原生首页接口
    * @description
    * @param router {number} 返回上一层（单一使用）
    * @returns void
    * @author ningwenlei 2025.10.21
    */
   jumpHomePage: function (obj) {
    console.log('调用去原生首页',obj);
    native.jumpHomePage(obj)
  },
  /**
    * @function 返回原生登录接口
    * @description
    * @param router {number} 返回上一层（单一使用）
    * @returns void
    * @author ningwenlei 2025.10.21
    */
   jumpLogin: function (obj) {
    console.log('调用去原生登录',obj);
    native.jumpLogin(obj)
  },
 /**
    * @function 获取文件内容接口
    * @description
    * @param fileType {String} 文件类型 缺省值空值无文件类型限制；多个文件类型限制使用英文;分割 列 pdf;jpg
    * @param fileSize {int} 单个文件大小限制 单位M 缺省值-1 无文件大小限制
    * @param fileCount {int} 选取文件数量限制 缺省值-1  无文件数量限制
    * @param hasContent {int} 是否返回文件内容 1：返回 0: 不返回
    * @returns Promise
    * @author kongxiangcheng 2022.09.13
    */
  getFileContent: function (fileType, fileSize, fileCount, hasContent) {
    let param =JSON.stringify({
      fileType: fileType,
      fileSize: fileSize,
      fileCount: fileCount,
      hasContent: hasContent
    })
    return native.getFileContent(param)
  },
  /**
    * @function SM4加解密接口
    * @description
    * @param mode {int}机密类型/方式 ）0：加密 1：解密
    * @param model {int} 加密模式 0：ECB 1：CBC ECB时IV传null CBC时IV传String
    * @param data {String} 待加解密数据
    * @param key {String} 对称密钥
    * @param iv {String} 偏移量
    * @returns Promise
    * @author kongxiangcheng 2022.09.13
    */
  SM4SymEnDecrypt: function (mode, model, data, key, iv) {
    let param =JSON.stringify({
      mode: mode,
      model: model,
      data: data,
      key: key,
      iv:iv
    })
    return native.SM4SymEnDecrypt(param)
  },
      /**
    * @function 原生支付接口
    * @description
    * @param appType {String} 选择不同类型APP支付 '1':支付宝支付 '2':云闪付
    * @param object {Object} 根据不同的参数扩展不同的字段 详情请见移动端公共接口11.2.2章节
    * @returns Promise
    * @author kongxiangcheng 2023.06.19
    */
  openPaymentApp: function (appType,object) {
   let param =JSON.stringify({
		appType: appType,
		object: object,
	})
    return native.openPaymentApp(param)
  },
   /**
    * @function 唤醒第三方应用
    * @description
    * @param appType {String} app类型
    * @param object {Object} 根据不同的参数扩展不同的字段 详情请见移动端公共接口11.1.2章节
    * @returns Promise
    * @author kongxiangcheng 2023.06.28
    */
  launchApp: function (appType,object) {
    let param =JSON.stringify({
		appType: appType,
		title: '即将离开APP,打开浏览器',
		object: object,
		                                                                                                                                                                          
	})
    return native.launchApp(param)
  },
   /**
    * @function 唤醒第三方应用测试版本
    * @description
    * @param appType {String} app类型
    * @param object {Object} 根据不同的参数扩展不同的字段 详情请见移动端公共接口11.1.2章节
    * @returns Promise
    * @author kongxiangcheng 2023.06.28
    */  
  launchAppTest: function (appType,object) {
	  object.appType = appType
	  object.title = '即将离开APP,打开浏览器'
    let param =JSON.stringify(object)
    return native.launchApp(param)
  },
  /**
    * @function 获取设备信息
    * @description
    * @returns Promise
    * @author kongxiangcheng 2025.09.11
    */  
  getDeviceInfo: function () {
    return native.getDeviceInfo()
  },
  /**
    * @function  打开新的webview窗口
    * @description
    * @param url {String} webview需访问的地址
    * @param object {Object} 根据不同的参数扩展不同的字段 详情请见移动端公共接口14.2.1章节
    * @returns Promise
    * @author kongxiangcheng 2025.12.05
    */
  openWebView: function (url,object) {
    let param =JSON.stringify({
		url: url,
		object: object,                                                                                                                                                                         
	})
    return native.openWebView(param)
  },
};
export default nativeApi
